
import React from 'react';
import { Shield } from 'lucide-react';

const SuperAdminSettingsHeader: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold flex items-center">
        <Shield className="mr-2 h-6 w-6 text-primary" />
        System Settings
      </h1>
      <p className="text-muted-foreground">
        Configure global system settings for the entire SaaS platform
      </p>
    </div>
  );
};

export default SuperAdminSettingsHeader;
